import {
    RaikoSectionContainer,
    RaikoBaseCardContainer,
    RaikoMaterialOutlinedInput,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoFlexFirstChildGrowOne,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoConfirmDialog,
    showSuccessMessage,
    RaikoCreatorInfo,
    convertUniversalDateTimeToPersianDateTime,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components"
import React, {useEffect, useState} from "react";
import {FeaturesService} from "../../serverService/featuresService/FeaturesService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useNavigate, useParams} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../component/tabBoxContainer/TabBoxContainer";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabList from "@mui/lab/TabList";
import {stringIsEmpty} from "../../util/VariableChecker";


export default function FeatureDetail() {


    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [createdAt, setCreatedAt] = useState("")
    const [createdBy, setCreatedBy] = useState("")
    const [loadingButton, setLoadingButton] = useState(false)


    const {id: featureId} = useParams()

    // const [loading, setLoading] = useState();
    const service = new FeaturesService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getFeatureDetailFromServer()
        }
    }, []);

    function getFeatureDetailFromServer() {
        loading.show()
        service.getFeatureDetail(featureId).then(
            response => {
                setTitle(response.title)
                setDescription(response.description)
                setCreatedAt(convertUniversalDateTimeToPersianDateTime(response.createdAt))
                setCreatedBy(response.createdBy)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const navigate = useNavigate()


    const [tabValue, setTabValue] = useState(FeatureDetailTabTypes.FeatureDetails.id);


    function handleChangeTab(event, newValue) {
        setTabValue(newValue)
    }

    function handleDeleteFeature() {
        loading.show()
        service.deleteFeature(featureId).then(
            response => {
                showSuccessMessage("حذف ویژگی با موفقیت انجام شد.")
                closeDeleteDialog()
                navigate(
                    RouteHelper.Features.globalUrl,
                    {replace: true}
                )
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    const [openDialog, setOpenDialog] = useState(false);
    const openDeleteDialog = () => setOpenDialog(true)
    const closeDeleteDialog = () => setOpenDialog(false)

    function checkingAllInputs() {
        let state = false;
        let message
        if (stringIsEmpty(title))
            message = "لطفا عنوان ویژگی را وارد نمایید."
        else if (stringIsEmpty(description))
            message = "لطفا جزئیات ویژگی را وارد نمایید."
        else
            state = true
        if (message)
            showWarningMessage(message)
        return state
    }


    function handleUpdate() {
        setLoadingButton(true)
        if (checkingAllInputs()) {
            service.updateFeature(featureId, title, description).then(
                response => {
                    showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                }
            ).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                setLoadingButton(false)
            })
        }
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.FeatureDetail.name}</title>
            </Helmet>
            <RaikoConfirmDialog
                cancelAction={closeDeleteDialog}
                openConfirmDialog={openDialog}
                doAction={handleDeleteFeature}
                pageTitle={"حذف ویژگی"}
                warningTitle={"آیا از حذف ویژگی اطمینان دارید؟"}
            />
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={
                                [raikoBreadCrumbItemGenerator(
                                    RouteHelper.Features.name,
                                    RouteHelper.Features.url
                                ),
                                    raikoBreadCrumbItemGenerator(
                                        RouteHelper.FeatureDetail.name,
                                        ""
                                    )
                                ]
                            }
                        />
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>

                    </RaikoFlexFirstChildGrowOne>
                    <TabContext value={tabValue}>
                        <TabBoxContainer>
                            <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon" className={"ic-profile"}/>} iconPosition="start"
                                     label={FeatureDetailTabTypes.FeatureDetails.title}
                                     value={FeatureDetailTabTypes.FeatureDetails.id}/>
                            </TabList>
                        </TabBoxContainer>
                        <TabPanel value={FeatureDetailTabTypes.FeatureDetails.id}>
                            <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        hasSecondaryButton
                                        secondaryButtonTitle={"حذف"}
                                        secondaryButtonOnClick={openDeleteDialog}
                                        title={"ویرایش ویژگی"}
                                        hasActionButton
                                        actionButtonTitle={"بروزرسانی"}
                                        actionButtonOnclick={handleUpdate}
                                        actionButtonLoadingState={loadingButton}
                                    >
                                        <RaikoMaterialOutlinedInput
                                            labelText={"عنوان"}
                                            value={title}
                                            setValue={setTitle}
                                        />
                                        <RaikoSimpleMultiLineInputOutlined
                                            labelText={"توضیحات"}
                                            value={description}
                                            setValue={setDescription}
                                        />
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>
                                <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
                            </RaikoGridOneColumn>


                        </TabPanel>

                    </TabContext>

                </RaikoGridOneColumn>

            </RaikoBaseContainer>

        </>

    )
}
const FeatureDetailTabTypes = {
    FeatureDetails: {
        id: "feature-details",
        title: "جزئیات ویژگی"
    },
}